import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ed90739"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pause-ending-soon-modal__text mb-2" }, " Подписка будет автоматически возобновлена, а оплата спишется с привязанной карты. ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pause-ending-soon-modal__text mb-2" }, " Если вы не планируете пользоваться PRO, отмените подписку до окончания периода паузы. ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pause-ending-soon-modal__text mb-2" }, " После отмены подписки тариф PRO станет недоступен для подключения, останутся только актуальные тарифы и отдельные платные опции. ", -1))

import { computed, ref } from 'vue';
import TariffNotificationModal from '../../TariffNotificationModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PauseEndingSoonModal',
  props: {
    pauseEndsAt: {}
  },
  emits: ["confirm", "secondary", "hidden"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const modalRef = ref<InstanceType<typeof TariffNotificationModal>>();

const formattedDate = computed(() => {
    const date = new Date(props.pauseEndsAt);
    if (Number.isNaN(date.getTime())) {
        return '';
    }

    return date.toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
    });
});

function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

__expose({
    show: showModal,
    hide: hideModal,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TariffNotificationModal, {
    ref_key: "modalRef",
    ref: modalRef,
    title: `Пауза PRO заканчивается ${formattedDate.value}`,
    "button-text": "Оплатить PRO",
    "secondary-button-text": "Отменить подписку",
    "max-width": 450,
    onButtonClick: _cache[0] || (_cache[0] = ($event: any) => (emit('confirm'))),
    onSecondaryButtonClick: _cache[1] || (_cache[1] = ($event: any) => (emit('secondary'))),
    onHidden: _cache[2] || (_cache[2] = ($event: any) => (emit('hidden')))
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})